// Keep the anonymous bootstrap scope small and limited to student-entry routes.
export function shouldBootstrapAnonymous(pathname: string): boolean {
  return (
    pathname === '/subjects' ||
    pathname === '/universities' ||
    pathname === '/placement' ||
    pathname === '/onboarding' ||
    pathname.startsWith('/courses/')
  )
}
